import { utils } from "../../utils";


const cartItems = JSON.parse(localStorage.getItem(utils.constants.localStorage_cart)) || []
const reducer_cart = (state = { cartItems }, action) => {
    switch (action.type) {
        case utils.constants.CART_ITEMS_REMOVE:
        case utils.constants.CART_ITEMS_ADD: {
            return {
                ...state,
                cartItems: action.payload.cartItems
            }            
        }
        case utils.constants.ORDER_CREATE_SUCCESS_CLEAT_CART: {
            return {
                cartItems:[]
            }
        }
        // case utils.constants.CART_ITEMS_REMOVE: {
        //     return {

        //     }
        // }



        default:
            return { ...state }

    }
}

export default reducer_cart